<template>
  <section class="bg-gray-50 dark:bg-gray-900">
    <div v-if="!succesRegister" class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <auth-form title="Rejoins la team déglingo">
        <div class="space-y-4 md:space-y-6">
          <input-field
              label="Prénom"
              v-model="dataForm.firstname"
              type="text"
              placeholder="Prénom.."
              :validation="v$.dataForm.firstname"
          />
          <input-field
              label="Nom"
              v-model="dataForm.lastname"
              type="text"
              placeholder="Nom.."
              :validation="v$.dataForm.lastname"
          />
          <input-field
              label="Email"
              v-model="dataForm.email"
              type="email"
              placeholder="example@email.com"
              :validation="v$.dataForm.email"
          />
          <input-field
              label="Mot de passe"
              v-model="dataForm.password"
              type="password"
              placeholder="••••••••"
              :validation="v$.dataForm.password"
          />
          <bouton-form-auth :is-loading="isLoading" @click="submit" text="Je m'inscris" />

          <p class="text-sm font-light text-gray-500 dark:text-gray-400">
            Déjà un compte?
            <router-link :to="{ name: 'app_login' }" class="font-medium text-primary-700 hover:underline dark:text-primary-500">Me connecter</router-link>
          </p>
        </div>
      </auth-form>
    </div>
    <div v-else class="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
      <h1 class="text-2xl lg:text-5xl text-primary-700 mb-5">BRAVO, votre compte déglingo viens d'être créé !</h1>
      <router-link to="/connexion" class="text-white bg-primary-700 hover:bg-primary-700 focus:ring-4 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center">
        Me connecter
      </router-link>
    </div>
  </section>
</template>

<script>
import AuthForm from "@/components/auth/AuthForm.vue";
import {api} from "@/modules/api";
import {reactive} from "vue";
import {email, helpers, required} from "@vuelidate/validators";
import {useVuelidate} from "@vuelidate/core";
import BoutonFormAuth from "@/components/bouton/BoutonFormAuth.vue";
import InputField from "@/components/input/InputField.vue";

export default {
  name: 'RegisterView',
  components: {InputField, BoutonFormAuth, AuthForm},
  setup() {
    const dataForm = reactive({
      firstname: '',
      lastname: '',
      email: '',
      password: ''
    });

    const rules = {
      dataForm: {
        email: {
          required: helpers.withMessage('Ce champs est obligatoire', required),
          email: helpers.withMessage('Le format de l\'email n\'est pas valide', email)
        },
        firstname: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        lastname: { required: helpers.withMessage('Ce champs est obligatoire', required) },
        password: { required: helpers.withMessage('Ce champs est obligatoire', required) }
      }
    };

    const v$ = useVuelidate(rules, { dataForm })

    return { dataForm, v$ }
  },
  data () {
    return {
      isLoading: false,
      error: null,
      viewModal: false,
      succesRegister: false
    }
  },
  methods: {
    submit () {
      this.isLoading = true
      this.v$.$touch();
      if (this.v$.$invalid) {
        this.isLoading = false
        return;
      }

      api.auth.register(this.dataForm).then(res => {
        if (res) {
          this.succesRegister = true
        }
      })
    }
  }
}
</script>